export const colorSteps = [
  [0, '#FFF3EC'],
  [20, '#F6C6B6'],
  [54, '#EB988B'],
  [172, '#DD676D'],
  [434, '#C1375D'],
  [4782, '#911A52'],
  [19054, '#610042'],
  [50000]
];
